import angular from 'angular';
import _ from 'underscore';

export default class UserRegister {
  constructor($scope, GeoService, UserService) {
    $scope.tabs = ['1. Account Details',
      '2. Company Details',
      '3. Personal Details',
      '4. Role Details',
      '5. Product Categories & Groups'
    ];

    $scope.get_new_user = function() {
      return {
        user_type: 'Buyer',
        company_title: null,
        company_email: null,
        country_id: null,
        city_id: null,
        phone: null,
        fax: null,
        ssn: null,
        business_relation: 0,
        last_name: '',
        market: 'global',
        is_past_customer: 0,
        user_contacts_attributes: [{
          department_id: null,
          email: null,
          first_name: null,
          last_name: null,
          gender: 0,
          position: null,
          phone: null,
          fax: null,
          newsletter_settings: null,
          matching_settings: null,
          frontend_settings: null,
          welcome_email_date: null
        }],
        user_groups_attributes: [],
        user_business_types_attributes: [],
        user_product_categories_attributes: [],
        user_product_groups_attributes: []
      };
    };

    $scope.get_new_account = function() {
      return {
        username: null,
        password: null,
        retype_password: null,
        status: 'pending'
      };
    };

    $scope.$watch('user.country_id', function() {
      if ($scope.user.country_id) {
        GeoService.get_cities($scope.user.country_id).then(function(data) {
          $scope.cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.user.city_id}))
            $scope.user.city_id = null;
        });
      }
    });

    $scope.$watch('user.user_type', function() {
      $scope.business_types = angular.copy(window.business_types);
      $scope.user.user_business_types_attributes = [];
    });

    $scope.category_changed = function(category) {
      if (!category.checked) {
        for (var i = 0; i < category.groups.length; i++)
          category.groups[i].checked = false;
      }
    };

    $scope.group_changed = function(category, group) {
      if (group.checked && !category.checked)
        category.checked = true;
    };

    $scope.show_next_tab = function() {
      $scope.processing = true;
      $scope.reset_errors();
      $scope.validate_step();
    };

    $scope.validate_step = function() {
      if ($scope.selected_tab == 0) {
        if ($scope.validate_username() && $scope.validate_password()) {
          UserService.register_account_email_exists($scope.account.username).then(function(data) {
            if (data.exists) {
              $scope.account_email_error = 'Email already exists!';
            } else {
              $scope.selected_tab++;
            }
            $scope.processing = false;
          });
        }
      } else if ($scope.selected_tab == 1) {
        if ($scope.validate_company() && $scope.validate_country() && $scope.validate_email()) {
          $scope.selected_tab++;
          $scope.processing = false;
        }
      } else if ($scope.selected_tab == 2) {
        if ($scope.validate_department() && $scope.validate_first_name() && $scope.validate_last_name() && $scope.validate_contact_email()) {
          $scope.selected_tab++;
          $scope.processing = false;
        }
      } else if ($scope.selected_tab == 3) {
        $scope.get_business_types();
        if ($scope.user.user_business_types_attributes.length > 0) {
          $scope.selected_tab++;
        } else {
          $scope.business_type_error = 'Please select at least one business type!';
        }
        $scope.processing = false;
      } else if ($scope.selected_tab == 4) {
        $scope.get_product_data();
        if ($scope.user.user_product_categories_attributes.length > 0) {
          $scope.save_data();
        } else {
          $scope.categories_error = 'Please select at least one product category!';
          $scope.processing = false;
        }
      }
    };

    $scope.save_data = function() {
      UserService.save_register_data($scope.user, $scope.account).then(function(data) {
        if (data.success) {
          //to-do
        } else {
          //to-do
        }
        $scope.processing = false;
      });
    };

    $scope.reset_errors = function() {
      $scope.account_email_error = null;
      $scope.account_password_error = null;
      $scope.user_company_error = null;
      $scope.user_country_error = null;
      $scope.user_email_error = null;
      $scope.user_department_error = null;
      $scope.user_first_name_error = null;
      $scope.user_last_name_error = null;
      $scope.user_contact_email_error = null;
      $scope.business_type_error = null;
      $scope.categories_error = null;
    };

    $scope.validate_username = function() {
      if ($scope.account.username && $scope.account.username.length > 6) {
        return true;
      } else {
        $scope.account_email_error = 'Missing or invalid email!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_password = function() {
      var password = $scope.account.password;
      var password2 = $scope.account.retype_password;
      if (!(password || password2) || password.length == 0 || (password != password2)) {
        $scope.account_password_error = 'Password empty or password mismatch!';
        $scope.processing = false;
        return false;
      }
      return true;
    };

    $scope.validate_company = function() {
      if ($scope.user.company_title && $scope.user.company_title.length > 1) {
        return true;
      } else {
        $scope.user_company_error = 'Missing or invalid company title!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_country = function() {
      if ($scope.user.country_id) {
        return true;
      } else {
        $scope.user_country_error = 'Missing country!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_email = function() {
      if ($scope.user.company_email && $scope.user.company_email.length > 6) {
        return true;
      } else {
        $scope.user_email_error = 'Missing or invalid email!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_contact_email = function() {
      if ($scope.user.user_contacts_attributes[0].email && $scope.user.user_contacts_attributes[0].email.length > 6) {
        return true;
      } else {
        $scope.user_contact_email_error = 'Missing or invalid email!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_department = function() {
      if ($scope.user.user_contacts_attributes[0].department_id) {
        return true;
      } else {
        $scope.user_department_error = 'Missing department!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_first_name = function() {
      if ($scope.user.user_contacts_attributes[0].first_name && $scope.user.user_contacts_attributes[0].first_name.length > 0) {
        return true;
      } else {
        $scope.user_first_name_error = 'Missing or invalid first name!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.validate_last_name = function() {
      if ($scope.user.user_contacts_attributes[0].last_name && $scope.user.user_contacts_attributes[0].last_name.length > 0) {
        return true;
      } else {
        $scope.user_last_name_error = 'Missing or invalid last name!';
        $scope.processing = false;
        return false;
      }
    };

    $scope.get_business_types = function() {
      $scope.user.user_business_types_attributes = [];
      angular.forEach($scope.business_types, function(business_type) {
        if (business_type.checked)
          $scope.user.user_business_types_attributes.push({
            business_type_id: business_type.id
          });
      });
    };

    $scope.get_product_data = function() {
      $scope.user.user_product_categories_attributes = [];
      $scope.user.user_product_groups_attributes = [];
      angular.forEach($scope.product_categories, function(category) {
        if (category.checked)
          $scope.user.user_product_categories_attributes.push({
            product_category_id: category.id
          });
        for (var i = 0; i < category.groups.length; i++) {
          if (category.groups[i].checked)
            $scope.user.user_product_groups_attributes.push({
              product_group_id: category.groups[i].id
            });
        }
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.user = $scope.get_new_user();
      $scope.account = $scope.get_new_account();
      $scope.business_types = angular.copy(window.business_types);
      $scope.product_categories = angular.copy(window.product_categories);
    };

    $scope.init();
  }
}

UserRegister.$inject = ['$scope', 'GeoService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-register.ctrl.js